const platforms = {
  android: {
    id: 'android',
    scope: 'ANDROID',
    title: 'Android端获取',
    subtitle: 'OFFICIAL ANDROID CHANNELS',
    state: 'open',
    stateText: '已开放',
    open: true,
    mark: 'APK',
    featuredLabel: '官网 APK 直装',
    name: 'Android 官方 APK',
    description: '从宇宙之幂官方服务器下载已签名 APK；部分设备需允许当前浏览器安装应用。',
    meta: ['APK 直装', '官方校验', '手动更新'],
    action: '下载 APK',
    note: 'Android 版本已开放，请通过官网下载 APK。',
    channels: []
  },
  ios: {
    id: 'ios',
    scope: 'APPLE',
    title: 'iOS端获取',
    subtitle: 'APPLE DISTRIBUTION',
    state: 'soon',
    stateText: '11月内开放（内测中）',
    open: false,
    mark: 'iOS',
    featuredLabel: 'App Store 正式分发',
    name: 'iPhone 与 iPad 客户端',
    description: '正式版通过 App Store 安装；iOS 版本正在准备中。',
    meta: ['App Store', '统一账号', '系统自动更新'],
    action: '等待上架',
    note: 'iOS 正式版将通过 App Store 提供。',
    channels: [
      { mark: 'AS', name: 'App Store', description: '正式版渠道', accent: '#6cbcff', icon: 'https://cdn.simpleicons.org/appstore/0D96F6' },
    ]
  },
  harmony: {
    id: 'harmony',
    scope: 'HARMONYOS',
    title: 'HarmonyOS端获取',
    subtitle: 'HARMONYOS DISTRIBUTION',
    state: 'soon',
    stateText: '11月内开放（内测中）',
    open: false,
    mark: 'HM',
    featuredLabel: '华为应用市场分发',
    name: 'HarmonyOS 客户端',
    description: '正式版计划通过华为应用市场发布；元服务为独立的免安装入口，并非客户端安装包。',
    meta: ['AppGallery', '原生鸿蒙', '自动更新'],
    action: '等待上架',
    note: 'HarmonyOS 客户端以华为应用市场为正式入口；元服务开放后可免安装使用。',
    channels: [
      { mark: 'AG', name: '华为应用市场', description: '客户端正式版', accent: '#ff5f62', icon: 'https://cdn.simpleicons.org/huawei/FF3C34' },
      { mark: 'MS', name: '鸿蒙元服务', description: '免安装独立入口', accent: '#ff9a55', icon: 'https://cdn.simpleicons.org/harmonyos/FFFFFF' }
    ]
  },
  windows: {
    id: 'windows',
    scope: 'WINDOWS',
    title: 'Windows（正式版）端获取',
    subtitle: 'WINDOWS DISTRIBUTION',
    state: 'soon',
    stateText: '11月内开放（内测中）',
    open: false,
    mark: 'WIN',
    featuredLabel: '官网安装包',
    name: 'Windows 官方安装包',
    description: '发布后可从官方服务器下载签名的 EXE、MSI 或 MSIX 安装包。',
    meta: ['签名安装包', '桌面版'],
    action: '等待发布',
    note: 'Windows 正式版通过官网签名安装包获取。',
    channels: []
  },
  macos: {
    id: 'macos',
    scope: 'MACOS',
    title: 'macOS端获取',
    subtitle: 'MAC DISTRIBUTION',
    state: 'soon',
    stateText: '11月内开放（内测中）',
    open: false,
    mark: 'MAC',
    featuredLabel: '官网公证安装包',
    name: 'macOS 官方安装包',
    description: '发布后可下载 Developer ID 签名并经 Apple 公证的 DMG 或 PKG。',
    meta: ['Apple 公证', 'Developer ID', 'Mac App Store'],
    action: '等待发布',
    note: 'macOS 可同时提供官网公证安装包与 Mac App Store 正式版。',
    channels: [
      { mark: 'MAS', name: 'Mac App Store', description: '商店正式版', accent: '#a9baff', icon: 'https://cdn.simpleicons.org/appstore/0D96F6' }
    ]
  },
  linux: {
    id: 'linux',
    scope: 'LINUX',
    title: 'Linux端获取',
    subtitle: 'LINUX DISTRIBUTION',
    state: 'soon',
    stateText: '11月内开放（内测中）',
    open: false,
    mark: 'LNX',
    featuredLabel: '官网软件包',
    name: 'Linux 官方安装包',
    description: '发布后可按发行版提供 DEB、RPM 或 AppImage，并同步 Deepin 应用商店、Snap Store 与 Flathub。',
    meta: ['DEB / RPM', 'AppImage', '软件商店'],
    action: '等待发布',
    note: 'Linux 可提供官网软件包，并按计划上架 Deepin 应用商店、Snap Store 与 Flathub。',
    channels: [
      { mark: 'DEEPIN', name: 'Deepin 应用商店', description: '深度应用商店', accent: '#008cff', icon: '/app-center-reference/static/platform-store-icons/deepin.svg' },
      { mark: 'SNAP', name: 'Snap Store', description: '跨发行版', accent: '#ffbd5a', icon: 'https://cdn.simpleicons.org/snapcraft/82BEA0' },
      { mark: 'FLAT', name: 'Flathub', description: 'Flatpak', accent: '#7e9dff', icon: 'https://cdn.simpleicons.org/flathub/4A86CF' }
    ]
  },
  web: {
    id: 'web',
    scope: 'WEB',
    title: 'Web端获取',
    subtitle: 'WEB ACCESS',
    state: 'soon',
    stateText: '即将开放',
    open: false,
    mark: 'WEB',
    featuredLabel: '浏览器直接访问',
    name: '宇宙之幂 Web 端',
    description: 'Web 端无需下载；开放后直接用浏览器访问，也可按浏览器提示安装为 PWA。',
    meta: ['浏览器直达', '无需安装包', '可选 PWA'],
    action: '等待开放',
    note: 'Web 端属于在线访问入口，不提供传统客户端安装包。',
    channels: [
      { mark: 'WEB', name: '浏览器访问', description: '网页直达入口', accent: '#47dfff', icon: 'web-access' },
      { mark: 'PWA', name: '安装 Web 应用', description: '由浏览器添加到设备', accent: '#a170ff', icon: 'https://cdn.simpleicons.org/pwa/5A0FC8' }
    ]
  },
  mini: {
    id: 'mini',
    scope: 'MINI PROGRAM',
    title: '小程序端获取',
    subtitle: 'MINI PROGRAMS',
    state: 'soon',
    stateText: '即将开放',
    open: false,
    mark: 'MINI',
    featuredLabel: '平台内搜索或扫码',
    name: '宇宙之幂小程序',
    description: '小程序在对应平台内打开，无独立安装包；发布后提供搜索名称、二维码或直达链接。',
    meta: ['平台内打开', '免安装', '扫码直达'],
    action: '等待开放',
    note: '小程序不提供安装包，请从对应平台搜索或扫码进入。',
    channels: [
      { mark: 'WX', name: '微信小程序', description: '微信生态', accent: '#66e486', icon: 'https://cdn.simpleicons.org/wechat/07C160' },
      { mark: 'ALI', name: '支付宝小程序', description: '支付宝生态', accent: '#5db7ff', icon: 'https://cdn.simpleicons.org/alipay/1677FF' },
      { mark: 'DY', name: '抖音小程序', description: '抖音生态', accent: '#ff5e86', icon: 'https://cdn.simpleicons.org/tiktok/FFFFFF' },
      { mark: 'BD', name: '百度智能小程序', description: '百度生态', accent: '#7d88ff', icon: 'https://cdn.simpleicons.org/baidu/2932E1' }
    ]
  }
}

const simulator = {
  id: 'simulator',
  scope: 'WINDOWS',
  title: 'Windows（先行版）下载',
  subtitle: 'OFFICIAL WINDOWS PREVIEW',
  state: 'open', stateText: '已开放', open: true,
  mark: 'WIN', featuredLabel: '官网下载', name: 'Windows（先行版）',
  description: '由宇宙之幂官方提供的 Windows 先行版。',
  meta: ['先行版', '官网下载'], action: '官网下载',
  note: 'Windows（先行版）请通过官网下载。', channels: []
}

const navigationEntries = [
  { id: 'android', kind: 'platform', label: 'Android', status: 'open', stateText: '已开放', accent: '#9eea42' },
  { id: 'simulator', kind: 'simulator', label: 'Windows（先行版）', status: 'open', stateText: '已开放', accent: '#4ff2ff' },
  { id: 'windows', kind: 'platform', label: 'Windows（正式版）', status: 'soon', stateText: '11月内开放（内测中）', accent: '#39bfff' },
  { id: 'ios', kind: 'platform', label: 'ios', status: 'soon', stateText: '11月内开放（内测中）', accent: '#62cfff' },
  { id: 'harmony', kind: 'platform', label: 'HarmonyOS', status: 'soon', stateText: '11月内开放（内测中）', accent: '#a778ff' },
  { id: 'macos', kind: 'platform', label: 'macOS', status: 'soon', stateText: '11月内开放（内测中）', accent: '#ff76bc' },
  { id: 'linux', kind: 'platform', label: 'Linux', status: 'soon', stateText: '11月内开放（内测中）', accent: '#ffd052' },
  { id: 'web', kind: 'platform', label: 'Web端', status: 'soon', stateText: '即将开放', accent: '#40eaff' },
  { id: 'mini', kind: 'platform', label: '小程序', status: 'soon', stateText: '即将开放', accent: '#ff63d5' }
]

function getProductOrderStatus(id) {
  return id === 'wearable' ? '12月内开放订购（生产中）' : '开放订购'
}

function getNavigationEntries() {
  return navigationEntries
}

function getPlatform(id) {
  return platforms[id]
}

function getView(id) {
  return id === simulator.id ? simulator : getPlatform(id)
}

function getPerimeterFlowStyle(index) {
  const cardCount = 17
  const phase = ((index % cardCount) + cardCount) % cardCount
  const delay = Number((phase * 5.6 / cardCount).toFixed(3))

  return {
    '--perimeter-flow-delay': phase === 0 ? '0s' : `${-delay}s`
  }
}

function getFlowStyle(index) {
  const durations = [4.9, 5.45, 6.15, 6.8, 7.55, 8.25, 5.8, 7.15]
  const colorDurations = [8.6, 10.4, 12.7, 15.3, 9.5, 13.8, 16.6]
  const duration = durations[index % durations.length]
  const colorDuration = colorDurations[index % colorDurations.length]

  return {
    '--flow-phase': `${(index * 71 + 19) % 360}deg`,
    '--flow-delay': `${-((index * 0.83) % duration).toFixed(2)}s`,
    '--flow-duration': `${duration}s`,
    '--flow-hue-start': `${(index * 59 + 13) % 360}deg`,
    '--flow-color-delay': `${-((index * 1.17) % colorDuration).toFixed(2)}s`,
    '--flow-color-duration': `${colorDuration}s`
  }
}

function getStageMetrics(viewportWidth, viewportHeight) {
  const baseSize = 820
  const availableWidth = Math.max(280, viewportWidth - 16)
  const availableHeight = Math.max(280, viewportHeight - 16)
  const scale = Math.min(1.2, availableWidth / baseSize, availableHeight / baseSize)

  return {
    width: baseSize * scale,
    height: baseSize * scale,
    scale
  }
}

function getExperiencePolicy() {
  return {
    mode: 'full',
    autoplayOfficialPreview: true
  }
}

export default {
  getExperiencePolicy,
  getFlowStyle,
  getNavigationEntries,
  getPerimeterFlowStyle,
  getProductOrderStatus,
  getPlatform,
  getStageMetrics,
  getView,
  platforms,
  simulator
}



// WEBPACK FOOTER //
// ./src/download/download-center-model.js